import Vue from 'vue'
import Vuex from 'vuex'
import appConfig from '@/app.config.js'
import PlayerStore from '@/module-store/player.js'

import actions from './store/actions'
import mutations from './store/mutations'
import getters from './store/getters'
import quizCreatorLogs from './store/logs/quiz-creator'
import { defaultQuiz } from './store/util'

Vue.use(Vuex)

export default new Vuex.Store({

    modules: {
        player: PlayerStore
    },

    state: {

        credit: 0,

        isCreateQuestionSuccess: false,

        removeAppPaddingX: false,

        playingCurrentQuestionIndex: 0,

        isEndQuiz: false,

        playerCount: 0,

        isUploadingQuizImage: false,

        isUploadingQuizVideo: false,

        isUploadingBackgroundImage: false,

        isMuted: false,

        imageSearchList: null,

        imageServerSelect: null,

        question: defaultQuiz(),

        minimumQuestionToShare: 7,

        captchaResponse: null,

        modal: {
            main: {
                isOpen: false,
                title: 'Something wrong',
                message: ''
            }
        },

        loader: {
            main: {
                isLoading: false
            }
        },

        qrCodeOptions: {
            data: '',
            cellSize: 6,
        },

        isAudioLoaded: false,

        audioDefinite: new Audio(),

        audioPlucky: new Audio(),

        audioWrong: new Audio(),

        audioSilence: document.createElement('AUDIO'),

        intervalNoSleep: null,

        frontPageSetting: {
            background_type: '',
            background_color: appConfig.defaultBackgroundColor,
            background_image: '',
            background_image_source: ''
        },

        frontPageBackgroundSet: false,

        orderAbility: {},

        audioSpotify: document.getElementById('audioSongSrc'),
        masterQuizId: null,

        isPlaySongUser: true,
        isPlaySongMaster: false,

        delayAnswer: 0,
        delayQuestion: 30,
        timeLimit: true,

        masterSound: {
            questionMusic: true,
            effectMusic: true,
        },

        playerSound: {
            questionMusic: true,
            effectMusic: true,
        },

        progressBarStatus: true,

        masterResult: {
            playerAnswersBox: true,
            icon: true,
            topPlayerBox: true,
            bgBox: true
        },

        isApplyApproval: false,

        isShowSchoolList: false,

        isQuizNotFinishLogCreated: false,

        isActiveOnly: false,

        relateQuiz: [],

        parentQuizCode: null,

        showTopRightMenu: false,

        isReconnectPopup: false,

        userPlayingInfo: false,

        couponCode: null,

        isCreateNewQuiz: false,

        subjectList: [],

        subject: null,

        cacheQuestions: null,

        isPreviewMode: false,

        playMode: null,

        islived: false,

        uploadMedia: {
            open: false,
            location: null,
            answerIndex: 0
        },

        diffQuestionLength: [0, 0],

        isShowPaymentPopup: false,

        isShowWhitelistModal: false,

        whitelitModalData: null,

        isShowMergeReportModal: false,

        typeUpgradeModal: '',

        paymentModalTitle: '',
        paymentModalDescription: '',

        subPageMenu: [],

        pageSliderPopup: {
            show: false,
            slug: null
        },

        showNewsletterModal: false,

        showLogoutPopup: false,

        showFeideLogin: false,

        themeSystemSettings: null,

        geoLocation: null,

        shareSetting: {
            canRead: false,
            canEdit: false,
            canAccessReport: false,
        },

        enableToEditQuiz: false,

        systemSetting: null,

        quizByUser: [],

        originalUserReports: [],

        originalSharedReports: [],
    },

    mutations,

    getters,

    actions,

    plugins: [quizCreatorLogs]
})
